import './MainHeader.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { isAuthPage } from 'utils/utils';

import A from 'components/A';
import BackLink from 'components/BackLink';
import Button from 'components/Button';
import Icon from 'components/Icon';
import Logo from 'components/Logo';
import MainNav from 'components/MainNav';
import SearchComponent from 'containers/Search/SearchComponent';
import NavItem from "../NavItem";

export default class MainHeader extends React.Component {
    static propTypes = {
        hasToken: PropTypes.bool,
        hasUnreadMessages: PropTypes.bool.isRequired,
        pathname: PropTypes.string.isRequired,
        user: PropTypes.object.isRequired
    };

    _openCloseMenu() {
        document.body.classList.toggle('open-menu');
    }

    openCloseSearch() {
        document.body.classList.toggle('open-search');
    }

    render() {
        if(isAuthPage(this.props.pathname) === true || !this.props.hasToken) {
            return (
                <header className="c-auth-header">
                    <div className="c-auth-header--inner">
                        <A href="https://thehunt.agency">
                            <Logo
                                className="c-auth-header__logo"
                            />
                        </A>
                        <div className="c-auth-header__links">
                            <div className="c-nav-item">
                                <A
                                    className="c-nav-item__link"
                                    href="mailto:jennifer@thehunt.agency">
                                    Contact Us
                                </A>
                            </div>

                            <div className="c-nav-item">
                                <A
                                    className={`c-nav-item__link ${window.location.pathname === '/login' ? 'a-nav-item__link--active' : ''}`}
                                    to="/login">
                                    Log In
                                </A>
                            </div>

                            <A
                                className="c-button"
                                to="/request-invitation"
                            >
                                Join The Hunt
                            </A>
                        </div>
                    </div>
                </header>
            )
        } else {
            return (
                <header className="c-main-header">
                    <BackLink className="opportunity-details__back" />

                    <Button className="open-close-menu"
                            id="openCloseMenu"
                            noStyles
                            onClick={this._openCloseMenu.bind(this)}>
                        <div className="open-close-menu_inner">
                            <div className="menu-line line1"></div>
                            <div className="menu-line line2">
                                <div className="menu-line line4"></div>
                            </div>
                            <div className="menu-line line3"></div>
                        </div>
                    </Button>

                    <Logo
                        className="c-main-header__logo"
                    />

                    {this.props.user.company != null && (
                        <SearchComponent
                            hideSearch={this.openCloseSearch.bind(this)}
                        />
                    )}

                    <Button className="open-close-search"
                            noStyles
                            onClick={this.openCloseSearch.bind(this)}>
                        <Icon type="search" />
                    </Button>



                    <MainNav
                        hasUnreadMessages={this.props.hasUnreadMessages}
                        pathname={this.props.pathname}
                        user={this.props.user}
                    />
                </header>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/MainHeader/index.js